import { icons } from "../../../../../utils/icons";
import { useEffect, useState } from "react";
import { differenceInSeconds, format } from "date-fns";

interface ClienteCardProps {
  nome: string;
  cpf: string;
  status: number;
  isSelected?: boolean;
  text?: string;
  hora_ini_atendimento?: string;
  hora_atribuicao?: string;
  hora_fila: string;
  icon:
  | "whatsapp"
  | "sms"
  | "chatbot"
  | "email"
  | "portal"
  | "ligacao"
  | "agenteVirtual"
  | "webchat";
}

export const ClienteCard = ({
  nome,
  cpf,
  status,
  isSelected,
  text,
  icon,
  hora_fila,
  hora_ini_atendimento
}: ClienteCardProps) => {
  // const { getContagem, contagem, isMoreThan24 } = useContagemFila()
  const [contagem, setContagem] = useState('')
  // const [isMoreThan24, setIsMoreThan24] = useState(false)

  function formatarTempo(segundos: number) {
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const segundosRestantes = segundos % 60;
    // setIsMoreThan24(horas >= 24)

    const horaFormatada = String(horas).length < 2 ? `0${horas}` : horas;
    const minutosFormatados = String(minutos).length < 2 ? `0${minutos}` : minutos;
    const segundosFormatados = String(segundosRestantes).length < 2 ? `0${segundosRestantes}` : segundosRestantes;
    return `${horaFormatada}:${minutosFormatados}:${segundosFormatados}`;
  }

  function getContagem(hora: string) {
    const intervalId = setInterval(() => {
      const date = new Date(hora)
      const horarioAtual = new Date();
      const diff = differenceInSeconds(horarioAtual, date)
      // setIsMoreThan24(diff >= 24)
      setContagem(formatarTempo(diff))
    }, 1000); // Atualiza a cada segundo

    // Limpa o intervalo quando o componente é desmontado
    return () => clearInterval(intervalId);
  }


  useEffect(() => {
    if (status !== 3) {
      getContagem(hora_fila)
    }
  }, [])



  return (
    <>
      <div

        className={` min-w-md my-1 flex h-16 items-center justify-between z-0 rounded-sm  select-none bg-gray-100 p-1 ${isSelected && "border-2 border-primary"
          } `}
      >
        <div className="flex items-center  ">
          <div className="ml-1 text-gray-800  max-w-[180px] min-w-[180px]  ">
            <p className="text-[0.55rem] max-w-[100%] truncate overflow-hidden text-ellipsis font-bold">{nome}</p>
            <p className="mt-1 text-[0.6rem] underline">{cpf}</p>
          </div>
        </div>
        <div
          className={` flex flex-col  items-end  `}
        >
          <div className=" flex items-center justify-end ">
            <p className="mr-2 text-xs text-gray-600 whitespace-nowrap">{hora_fila && format(new Date(hora_fila), 'dd/MM HH:mm')}</p>
            {/* <Tooltip content={iconName} placement="bottom-end"> */}
            <div className="flex h-5 w-5 items-center justify-center rounded-full bg-primary ">
              <img
                src={icons[icon].icons}
                alt=""
                className="relative h-4 w-4"
              />
            </div>
            {/* </Tooltip> */}
          </div>
          <div
            className={`mt-2 w-full rounded-sm text-center ${status === 3 ? 'bg-gray-400' : 'bg-error'}`}
          //  ${!isMoreThan24 ? 'bg-yellow-icons' : status === 3 ? 'bg-gray-400' : 'bg-error'} 
          >
            {
              status === 3 ? (
                <p className="m-0.5 text-[0.6rem] font-light text-white whitespace-nowrap">{hora_ini_atendimento && format(new Date(hora_ini_atendimento), 'dd/MM/yyyy HH:mm')}</p>
              ) : (
                <p className="m-0.5 text-[0.6rem] font-light text-white whitespace-nowrap">{text && `${text} - `} {contagem}</p>
              )
            }

          </div>
        </div>
      </div>
    </>
  );
};
